import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AdjustmentRuleAction } from '../adjustmentRule.action';
import { AdjustmentRuleTranslator } from '../adjustmentRule.translator';

type IDependencies = IClientApiDependencySegment;

export const loadAdjustmentRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentRuleAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getAdjustmentRules().pipe(
      mergeMap((response) => {
        const result = (response.rules ?? []).map(AdjustmentRuleTranslator.fromApi);

        return [
          AdjustmentRuleAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          AdjustmentRuleAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
